"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeadServiceLineReplacementType = void 0;
var LeadServiceLineReplacementType;
(function (LeadServiceLineReplacementType) {
    LeadServiceLineReplacementType[LeadServiceLineReplacementType["Voluntary"] = 0] = "Voluntary";
    LeadServiceLineReplacementType[LeadServiceLineReplacementType["Emergency"] = 1] = "Emergency";
})(LeadServiceLineReplacementType = exports.LeadServiceLineReplacementType || (exports.LeadServiceLineReplacementType = {}));
//# sourceMappingURL=LeadServiceLineReplacementType.js.map